import forEach from '../../../../javascripts/dom/forEach';

const anchorsliders = document.querySelectorAll('[data-js-module="o-anchorslider"]');

const init = async () => {
  const { default: Anchorslider } = await import(/* webpackChunkName: "o-anchorslider" */ './anchorslider');
  forEach(anchorsliders, (index, element) => new Anchorslider(element));
};

if (anchorsliders.length) init();
